import { createContext, useState } from "react";

export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    token: localStorage.getItem("jwtToken"),
    refreshToken: localStorage.getItem("refreshToken"),
  });

  const saveAuthData = (Token, RefreshToken) => {
    localStorage.setItem("jwtToken", Token);
    localStorage.setItem("refreshToken", RefreshToken);
    setAuthData({ token: Token, refreshToken: RefreshToken });
  };

  const clearAuthData = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("refreshToken");
    setAuthData(null, null);
  };

  return (
    <AuthContext.Provider value={{ authData, saveAuthData, clearAuthData }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
